import { SingleProviderConfig, ShopType, CheckoutType } from 'types';
import { asyncEligible, getDefaultCrossSellAction } from 'config';
import {
  Astound,
  BuckeyeBroadband,
  Comcast,
  Cox,
  Mediacom,
  Optimum,
  Spectrum,
  TDS,
  WOW,
} from 'config/providers';
import { XfinityTheme } from 'config/themes';

export const XfinitySpecialZip: SingleProviderConfig = {
  name: 'XfinitySpecialZip',
  micrositeCode: 'ComcastZip',
  mainProvider: Comcast,
  shopType: ShopType.SINGLE_PROVIDER,
  domain: 'xfinityspecial.com',
  homepage: 'https://xfinityspecial.com/getinternet',
  commercialHomepage: 'https://comcastbusinessspecial.com',
  title: 'Xfinity Authorized Dealer',
  fallbackPhoneNumber: '844-426-1521',
  fallbackLeadModePhoneNumber: '866-495-3522',
  defaultCheckoutType: CheckoutType.LEAD_MODE,
  defaultTheme: XfinityTheme,
  needsDcSession: true,
  source: 'Xfinity',
  noOffersRetry: 2,
  getCrossSellAction: getDefaultCrossSellAction,
  crossSellProviders: [
    Cox,
    Spectrum,
    Mediacom,
    Optimum,
    Astound,
    WOW,
    TDS,
    BuckeyeBroadband,
  ],
  updaterCrossSellActive: false,
  getCheckoutType: asyncEligible,
};
